import { render } from "./CardFee.vue?vue&type=template&id=daf93856"
import script from "./CardFee.vue?vue&type=script&lang=js"
export * from "./CardFee.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__